import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    workspacesNavAriaLabel: string;
    addNewWorkspace: string;
    addWorkspace: string;
    error: string;
    navTitle: string;
    newWorkspace: {
        /** Title label for the new workspace item */
        title: string;
    };
    scrollToInvitedTo: string;
    scrollToWorkspace: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the workspaces navigation */
            workspacesNavAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.workspacesNavAriaLabel?c=1sgiub5atmkhc", defaultMessage: "Workspaces Navigation" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the add workspace button */
            addNewWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.addNewWorkspace?c=2ivx83ojj2o4i", defaultMessage: "Add new workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text label for the add workspace button */
            addWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.addWorkspace?c=4djfyrcbnbcn", defaultMessage: "Add workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when workspace list fails to load */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.error?c=eg7nv1j54omu", defaultMessage: "An error occurred retrieving workspaces list" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Navigation title for workspaces section */
            navTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.navTitle?c=2qdcenpfm5ojs", defaultMessage: "Workspaces" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text labels for the new workspace entry */
            newWorkspace: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title label for the new workspace item */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.newWorkspace.title?c=3um6drb4wackm", defaultMessage: "New Workspace" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for scrolling to the invited-to section */
            scrollToInvitedTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.scrollToInvitedTo?c=3c4ksb0dj7ac1", defaultMessage: "Scroll to Invited to" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for scrolling to a specific workspace */
            scrollToWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNav.scrollToWorkspace?c=43g2b40hk5gw", defaultMessage: "Scroll to Workspace" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
